import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";

export const setChildrenAgeHelper = (state: EngineStoreData, id: string, age: number, itemId: string) => ({
  cartAccommodationItems: state.cartAccommodationItems?.map((CAI) => {
    if (CAI.id === itemId) {
      return {
        ...CAI,
        children: CAI.children?.map((child) => (child.id === id ? { ...child, age } : child)),
      };
    }
    return CAI;
  }),
});
